// extracted by mini-css-extract-plugin
export default {"container":"vM-z","header":"wM-z","details":"xM-z","link":"yM-z"};